import { render, staticRenderFns } from "./GenderQuest.vue?vue&type=template&id=14cb8bc8&"
import script from "./GenderQuest.vue?vue&type=script&lang=js&"
export * from "./GenderQuest.vue?vue&type=script&lang=js&"
import style0 from "./GenderQuest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
